define([
	"csi/reflection",
	"dojo/_base/declare",
	"underscore",
	"SiteAdmin/AttributeMap/MappedAttributeId",
	"./SectionItemAttributeMapTable"
], function(reflection, declare, _, MappedAttributeId, SectionItemAttributeMapTable) {

	return declare(MappedAttributeId, {

		sourceClassName: SectionItemAttributeMapTable.SOURCE_CLASS_NAME,
		destinationClassNames: SectionItemAttributeMapTable.DEST_CLASS_NAMES,

		sourceAttributeNames: SectionItemAttributeMapTable.SOURCE_ATTR_NAMES,
		destinationAttributeNames: SectionItemAttributeMapTable.DEST_ATTR_NAMES,

		settings: null,

		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			this.settings = ctx.view._getSettings();
			return this.inherited(arguments);
		},

		_getCustomAttributesInner: function(className) {
			// summary: return an array of custom attributes (and relations), unsorted
			var optionalConfig = this.settings[SectionItemAttributeMapTable.DEST_OPTIONAL_CONFIG];

			var rc = reflection.getClass(className);
			return rc ? _.filter(rc.getAttributes(true), function(attr) {
				if (!attr.isCustom)
					return false;
				if (!attr.isOptional)
					return true;
				return optionalConfig[attr.getId()];
			}) : [];
		}
	});
});